import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import { usersKey } from './useUsersInfiniteQuery';

const userUnblockFn = ({ userId }: { userId: number }) => {
  return apiClient.patch(`${APP_SSO_URL}api/user/${userId}/blocking`, {
    blocking: false,
  });
};

export const useUserUnblockMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: userUnblockFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [usersKey()[0]] });
    },
  });
};
